import { Phone, AlertTriangle } from "lucide-react";
import { useT } from "../lib/i18n";

export const EmergencyBanner = ({ emergency }) => {
  const t = useT();
  if (!emergency?.is_emergency) return null;
  return (
    <div
      data-testid="emergency-alert-banner"
      className="bg-red-600 text-white p-5 sm:p-6 rounded-2xl shadow-xl border-4 border-red-700 animate-pulse-subtle"
      role="alert"
    >
      <div className="flex items-start gap-4">
        <AlertTriangle className="w-9 h-9 shrink-0" />
        <div className="flex-1">
          <h3 className="font-heading font-extrabold text-xl sm:text-2xl leading-tight">
            {t("emergency_heading")}
          </h3>
          <p className="mt-2 text-lg leading-relaxed">{emergency.message}</p>
          <a
            href="tel:911"
            data-testid="call-911-button"
            className="mt-4 inline-flex items-center gap-2 bg-white text-red-700 font-bold text-lg px-6 py-3 rounded-xl hover:bg-red-50 transition-colors active:scale-95"
          >
            <Phone className="w-5 h-5" /> {t("call_911")}
          </a>
        </div>
      </div>
    </div>
  );
};
